let componentsData: any;

try {
  componentsData = require('../../../../dist/components_json.json');
} catch (error) {
  console.warn('components_json.json non trouvé. Utilisation de valeurs par défaut.');
  componentsData = {};
}

import { Meta, StoryFn } from '@storybook/web-components';
import { withComponentControls, toKebabCase } from '@utils/utils';

const elementTag = 'spw-link';

const argTypes = withComponentControls(componentsData, { tag: elementTag });

const meta: Meta = {
  title: 'Composants/Lien',
  component: elementTag,
  argTypes,
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: `
Permet de naviguer vers d'autres pages, sections ou vers des ressources externes.

[<spw-link>Consulter la documentation</spw-link>](https://zeroheight.com/2310c7a1e/p/47998e-lien)
        `,
      },
    },
  },
};

export default meta;

function htmlContent(slot) {
  return /* HTML */ `${slot}`;
}

const Template: StoryFn = args => {
  const element = document.createElement(elementTag);
  const hasSlot = true;
  const slottedLabel = 'content';

  Object.entries(args).forEach(([key, val]) => {
    if (key.startsWith('on')) {
      element.addEventListener(key.substring(2).toLowerCase(), val);
    } else {
      if (key !== slottedLabel) {
        element.setAttribute(toKebabCase(key), val as string);
      }
    }
  });

  if (hasSlot) {
    element.innerHTML = htmlContent(args[slottedLabel]);
  }

  return element;
};

export const Primary = Template.bind({});
Primary.args = {
  content: 'Mon super lien',
  href: 'http://google.com',
  target: '_blank',
};

export const WithIcon = Template.bind({});
WithIcon.args = {
  content: 'Mon super lien avec icône',
  href: 'http://google.com',
  target: '_blank',
  icon: 'fa-arrow-right',
  iconPosition: 'right',
};
